export default __webpack_public_path__ + "static/media/error.f17b44d5.png";